import { render, staticRenderFns } from "./RenewalPriceForm.vue?vue&type=template&id=09674364&scoped=true&"
import script from "./RenewalPriceForm.vue?vue&type=script&lang=js&"
export * from "./RenewalPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./RenewalPriceForm.vue?vue&type=style&index=0&id=09674364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09674364",
  null
  
)

export default component.exports